import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { TopNav, BottomNav, MobileHeader } from "@/components/Navigation";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AboutPage from "@/pages/About";
import EventsPage from "@/pages/Events";
import LinksPage from "@/pages/Links";
import ChatPage from "@/pages/Chat";
import LoginPage from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminPage from "@/pages/Admin";

function Shell() {
  const location = useLocation();
  // Detect returning from OAuth: Emergent sends session_id in hash
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col">
      <TopNav />
      <MobileHeader />
      <main className="flex-1 pb-20 md:pb-0">
        <Routes>
          <Route path="/" element={<Navigate to="/about" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/links" element={<LinksPage />} />
          <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth-callback" element={<AuthCallback />} />
          <Route path="*" element={<Navigate to="/about" replace />} />
        </Routes>
      </main>
      <BottomNav />
    </div>
  );
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Shell />
            <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#18181b", border: "1px solid #27272a", color: "#fff" } }} />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
